import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8abea8dc")

_pushScopeId("data-v-8abea8dc")
const _hoisted_1 = { class: "logoff_wrap" }
const _hoisted_2 = { class: "logoff_content" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "title" }, "重要提示", -1)
const _hoisted_4 = { class: "logoff_footer" }
const _hoisted_5 = {
  key: 0,
  class: "checkmark"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 我已阅读并同意 ")
const _hoisted_7 = { class: "footer-button" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LogoffHeader = _resolveComponent("LogoffHeader")!
  const _component_LogoffSuccessModal = _resolveComponent("LogoffSuccessModal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_LogoffHeader, {
      title: `${_ctx.viewModel.title}-账号注销`
    }, null, 8, ["title"]),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", {
        class: "content",
        innerHTML: _ctx.viewModel.logoffContent
      }, null, 8, ["innerHTML"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", {
        class: "checkbox-wrapper",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleAgree && _ctx.toggleAgree(...args)))
      }, [
        _createVNode("div", {
          class: ["checkbox", { 'checked': _ctx.isAgree }]
        }, [
          (_ctx.isAgree)
            ? (_openBlock(), _createBlock("span", _hoisted_5))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _hoisted_6,
      _createVNode("span", {
        class: "logoff-notice-link",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openLogoffNotice && _ctx.openLogoffNotice(...args)))
      }, "账号注销须知")
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleConfirm && _ctx.handleConfirm(...args))),
        class: ["footer-button-item footer-button-confirm", { 'disabled': !_ctx.isAgree }]
      }, "确认注销", 2),
      _createVNode("div", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickClose && _ctx.clickClose(...args))),
        class: "footer-button-item footer-button-cancel"
      }, "取消")
    ]),
    _createVNode(_component_LogoffSuccessModal, { visible: _ctx.isSuccessModalVisible }, null, 8, ["visible"])
  ]))
})